import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"
import { useTenantUserRemoveMutation } from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"

export type TenantUserManageAddedItemProps = {
  user: UserFragment
  tenantId: number
  roleName?: string
  onRemoved(): void
}

function TenantUserManageAddedItem(props: TenantUserManageAddedItemProps) {
  const { user, tenantId, roleName, onRemoved } = props

  const [remove, { error, loading }] = useTenantUserRemoveMutation()
  errorToast(error, { title: "Failed to remove user from team" })

  function handleRemove() {
    remove({ variables: { tenantId, userId: user.Id } })
    onRemoved()
  }

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={formatUserName(user.FirstName, user.LastName)}
        secondary={user.Email}
      />
      {roleName && <Manage.Item.Badge>{roleName}</Manage.Item.Badge>}
      <ConfirmButton
        size="xs"
        variant="destructive"
        isSquare
        iconSrc="trash"
        content="Remove user from team"
        confirmContent="Remove?"
        confirmVariant="destructive"
        isLoading={loading}
        onConfirm={handleRemove}
      />
    </Manage.Item>
  )
}

export default TenantUserManageAddedItem
